export default __webpack_public_path__ + "img/4bf2111936693213994d986f71fb567e.png";